import { redirect, RouteObject } from 'react-router-dom'
import axios from 'axios'
import { base_url } from 'env'

// Import the new pages
import MilestonesPage from 'pages/Milestones/Milestones'
import MilestoneCreatePage from 'pages/Milestones/MilestoneCreate'
import MilestoneEditPage from 'pages/Milestones/MilestoneEdit'

const milestoneLoader = async ({ params }: { params: { id?: string } }) => {
  try {
    const response = await axios.get(`${base_url}/milestone/${params.id}`)
    return response.data
  } catch (error) {
    console.error(error)
    return redirect('/milestones')
  }
}

export const MilestoneRoutes: RouteObject[] = [
  {
    path: '/milestones',
    loader: async () => {
      try {
        const response = await axios.get(base_url + '/milestone/')
        return response.data
      } catch (error) {
        console.error(error)
        return []
      }
    },
    element: <MilestonesPage />,
  },
  {
    path: '/milestone/create',
    element: <MilestoneCreatePage />,
  },
  {
    path: '/milestone/:id/edit',
    loader: milestoneLoader,
    element: <MilestoneEditPage />,
  },
]
